import { render, staticRenderFns } from "./Monitoringserver.vue?vue&type=template&id=0b9f56a9"
import script from "./Monitoringserver.vue?vue&type=script&lang=js"
export * from "./Monitoringserver.vue?vue&type=script&lang=js"
import style0 from "./Monitoringserver.vue?vue&type=style&index=0&id=0b9f56a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports